import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@mui/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Tooltip from "@mui/material/Tooltip";
import download from '../images/download-doc.svg';
import "react-daterange-picker/dist/css/react-calendar.css";
import Divider from '@mui/material/Divider';
import "date-fns";
import spinner  from '../../assign-prescriptions/images/spinner.gif';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import SwipeableViews from 'react-swipeable-views';
import {AppBar, Tabs, Tab, Grid, Avatar} from '@mui/material';
import Typography from '@mui/material/Typography';
import Dashboard from '../temparature_monitoring/Dashboard';
import {IconButton} from "@mui/material";
import Box from '@mui/material/Box';

import moment from 'moment-timezone';
import {withTranslation} from "react-i18next";
import ILocalAGGrid, {
  getDefaultColDef,
  createServerSideDatasource,
  withDateColumnFilter,
  applyReportFilterModel,
  attachReportServerSideDatasource,
  withClickableCell,
  resolveGridRow,
} from "../../grid/iLocalAGGrid";
import getTypeByLang from "../../common/typeByLang";
import enLocale from "date-fns/locale/en-US";
import frLocale from "date-fns/locale/fr";
import {getDefaultDateRange, getDateRangeByPreset, formatFromDateForAPI, formatToDateForAPI} from "../../../utils/datetime.utils";
import {generateCSV} from "../../../utils/GenerateCSV";

function TabContainer({ children, dir, classes }) {
  return (
    <Typography component="div" dir={dir} style={{ padding: 8 * 3 }}>
      {children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
  dir: PropTypes.string.isRequired,
};

class EnhancedTableHead extends React.Component {
  createSortHandler = (property, field) => event => {
    this.props.onRequestSort(event, property, field);
  };

  render() {
    const {order, orderBy, sortId, t} = this.props;
    const rows = [
      { id: "firstname", numeric: false, disablePadding: false, label: t("Report.Payroll.FirstName"), padding:'10px', field: 'first_name' },
      { id: "lastname", numeric: false, disablePadding: false, label: t("Report.Payroll.LastName"), padding:'10px', field: 'last_name' },
      { id: "member_id", numeric: false, disablePadding: false, label: t("Report.Payroll.BadgeNumber"), padding:'10px', field: 'member_id' },
      { id: "store", numeric: false, disablePadding: false, label: t("Report.Payroll.Store"), padding:'10px', field: 'name' },
      { id: "box", numeric: false, disablePadding: false, label: t("Report.Payroll.Location"), padding:'10px', field: 'name' },
      { id: "deliverytype" , numeric: false, disablePadding: false, label: t("Report.Payroll.DeliverType"), padding:'10px', field: 'name' },
      { id: "binid", numeric: false, disablePadding: false, label: t("Report.Payroll.BIN") ,padding:'10px', field: 'bin_id' },
      { id: "rxno", numeric: false, disablePadding: false, label: t("Report.Payroll.RxHash"), padding:'10px', field: 'rx_no' },
      { id: "fillid", numeric: false, disablePadding: false, label: t("Report.Payroll.FillID"), padding:'10px', field: 'fill_id' },
      { id: "prescriptionnumber", numeric: false, disablePadding: false, label: t("Report.Payroll.PrescriptionNumber"), padding:'10px', field: 'prescriptionnumber' },
      { id: "OrderId", numeric: false, disablePadding: false, label: t("Report.Payroll.OrderID"), padding:'10px', field: 'order_id' },
      { id: "PrescriptionTxnId", numeric: false, disablePadding: false, label: t("Report.Payroll.TransactionID"), padding:'10px', field: 'prescription_txn_id' },
      { id: "stock_code", numeric: false, disablePadding: false, label: t("Report.Payroll.StockCode"), padding:'10px', field: 'stock_code' },
      { id: "pucode", numeric: false, disablePadding: false, label: t("Report.Payroll.PUCode"), padding:'10px', field: 'pucode'},
      { id: "ndccode", numeric: false, disablePadding: false, label: t("Report.Payroll.NDCCode"), padding:'10px', field: 'ndc_code' },
      { id: "drugname", numeric: false, disablePadding: false, label: t("Report.Payroll.DrugName") ,padding:'10px', field: 'drug_name'},
      { id: "qty", numeric: false, disablePadding: false, label: t("Report.Payroll.Qty"), padding:'10px', field: 'qty' },
      { id: "amount", numeric: false, disablePadding: false, label: t("Report.Payroll.AmountDue"), padding:'10px', field: 'amount' },
      { id: "stockeddate", numeric: false, disablePadding: false, label: t("Report.Payroll.StockDate"), padding:'10px', field: 'stock_code' },
      { id: "pickupdate", numeric: false, disablePadding: false, label: t("Report.Payroll.PickUpDate"), padding:'10px', field: 'pickup_date' },
    ];

    return (
      <TableHead sx={{ height: '56px' }}>
        <TableRow>
          {rows.map(row => {
            return (
              <TableCell
                key={row.id}
                numeric={row.numeric}
                padding={row.disablePadding ? "none" : "default"}
                sortDirection={orderBy === row.id ? order : false}
                sx={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: '0.75rem', fontWeight: '500'}}
               >
               {[
                  "store",
                  "deliverytype",
                  "binid",
                  "fillid",
                  "prescriptionnumber",
                  "OrderId",
                  "PrescriptionTxnId",
                  "ndccode",
                  "qty",
                  "amount",
                ].includes(row.id) ? (
                  <TableSortLabel style={{ cursor: "text" }}>{row.label}</TableSortLabel>
                ) : (
                <Tooltip
                  title={t("Global.Label.Filter.Sort")}
                  placement={row.numeric ? "bottom-end" : "bottom-start"}
                  enterDelay={300}
                 >
                  <TableSortLabel
                    active={orderBy === row.field && sortId === row.id}
                    direction={order}
                    onClick={this.createSortHandler(row.id, row.field)}
                  >
                    {row.label}
                  </TableSortLabel>
                </Tooltip>
                )}
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  sortId: PropTypes.string.isRequired
};
EnhancedTableHead = withTranslation()(EnhancedTableHead)

const styles = theme => ({
  root: {
    width: "100%",
  },
  table: {
    minWidth: 1020
  },
  tableWrapper: {
    overflowX: "auto"
  },
  dob: {
    paddingTop: '25px',
  },
  headerdiv:{
    paddingLeft:'15%',
    paddingTop:'10'
},
padding10px:{
  padding:'10px'
},
formControl: {
  margin: theme.spacing.unit,
  minWidth: 120,
  maxWidth: 390,
},
logoWrapper:
{
  position: 'absolute',
  width: '89%',
  height: '70%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  background: 'rgba(255,255,255,0.5)',
  zIndex:'7869'
},
spinner:{
  position: 'absolute',
  background: 'rgba(255,255,255,.4)',
  width: '100%',
  height: '100%',
  zIndex: '9999',
  top: 0,
  left: 0,
},
spinnerImage:{
  top: 'calc(50% - 32.5px)',
  left: 'calc(50% - 65px)',
  position: 'absolute',
  width: '130px',
  userSelect:'none'
},
hidden :{
    display:'none'
 },
 rowheight: {
   height: '35px'
 },
primaryButton: {
  background: '#6cca98',
  color: '#fff',
  '&:hover': {
    background: '#6cca98',
    color: '#fff',
  },
  '&:disabled': {
    color: 'rgba(0, 0, 0, 0.38)',
    cursor: 'not-allowed',
    background: '#E4E5E8'
  },
}
});

const __reportDefaultDates = getDefaultDateRange();

let TransactionFilterObj = {
  store_ids:[],
  box_ids:[],
  searchtext:'',
  fromdate: formatFromDateForAPI(__reportDefaultDates.fromDate),
  todate: formatToDateForAPI(__reportDefaultDates.toDate),
  pageNo: 0,
  pageSize: 10,
  sortOrder: 'desc',
  sortColumn: 'pickup_date',
  tableName: '',
  group_id: null
}

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment().tz(timeZone).utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;

class EnhancedTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      order: "desc",
      dob: '',
      orderBy: "created_on",
      page: 0,
      rowsPerPage: 10,
      searchtext:'',
      store_id:[],
      box_id:[],
      fromdate:null,
      todate:null,
      dateRangePreset: 'last7days',
      isOpen: false,
      stores: [],
      boxes:[],
      boxvalues: [],
      accountValues: [],
      nstores:[],
      nboxes:[],
      chipstores:[],
      chipboxes:[],
      loader:false,
      selectedObject:null,
      isDataEmpty:true,
      selectedTab: 0,
      tempThresholds: [],
      totalRecords : 0,
      isButtonDisabled: false,
      locale: localStorage.getItem('i18nextLng') === 'en' ? enLocale : frLocale,
      queryId: "",
      groups: [],
   };
    this.handleStoreChange = this.handleStoreChange.bind(this);
    this.handleBoxChange = this.handleBoxChange.bind(this);

  }

  refreshGrid = () => {
    if (!this.gridApi) return;
    if (typeof this.gridApi.refreshServerSideStore === "function") {
      this.gridApi.refreshServerSideStore({ purge: true });
    } else if (typeof this.gridApi.refreshServerSide === "function") {
      this.gridApi.refreshServerSide({ purge: true });
    }
  };

  onPaginationChanged = (params) => {
    if (!params.api) return;
    const newPageSize = params.api.paginationGetPageSize();
    if (newPageSize && TransactionFilterObj.pageSize !== newPageSize) {
      TransactionFilterObj.pageSize = newPageSize;
    }
  };

  onGridReady = (params) => {
    this.gridApi = params.api;
    const datasource = createServerSideDatasource({
      filterBody: TransactionFilterObj,
      applyFilterModel: (body, filterModel) => {
        applyReportFilterModel(body, filterModel, { dateColIds: ['pickupdate'] });
      },
      pageZeroBased: true,
      getPageSize: () => TransactionFilterObj.pageSize || 10,
      fetchPage: (body) =>
        fetch(process.env.REACT_APP_BASEURL + "getPayrollDeductReport", {
          method: "post",
          withCredentials: true,
          headers: {
            Authorization:
              "Bearer " +
              JSON.parse(sessionStorage.getItem("user")).signInUserSession
                .idToken.jwtToken,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        })
          .then((r) => r.json())
          .then((data) => {
            if (data && data.results) return data;
            if (data && data.data && data.data.results) {
              return { results: data.data.results, total: data.data.total };
            }
            if (Array.isArray(data)) return { results: data, total: data.length };
            return {
              results: (data && (data.rows || data.data)) || [],
              total: (data && data.total) || 0,
            };
          }),
      onSuccess: (results, total) => {
        this.setState({
          data: results,
          totalRecords: total,
          loader: false,
          isDataEmpty: !results || results.length === 0,
        });
      },
      onError: () => this.setState({ loader: false }),
    });
    attachReportServerSideDatasource(params, datasource, TransactionFilterObj, 'pickupdate');
  };

  componentDidMount() {
    TransactionFilterObj.group_id = sessionStorage.getItem("groupID")
    this.setState({loader:true});
    fetch(process.env.REACT_APP_BASEURL +  "accounts", {
      method: 'GET',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.json())
    .then(accounts => {
      const {t} = this.props;
      let All = [{id: "-1", name: t("Global.Label.DropDown.All")}]
      const storelist = accounts.map(account => {
        return { id: account.id, name: account.name };
      });

      const accountValues = All.concat(storelist);
      this.setState({ accountValues,  parent_account_id: accountValues[0].id });
      this.BindBoxesbyStoreId(storelist.map(x => x.id));
      this.setState({loader:false});
    });
    // Set default date range (T-30 days to today)
    const defaultDates = getDefaultDateRange();
    this.setState({ 
      fromdate: defaultDates.fromDate,
      todate: defaultDates.toDate,
      dateRangePreset: 'last7days'
    });

    Object.assign(TransactionFilterObj, {
      store_ids:[],
      box_ids:[],
      searchtext:'',
      fromdate: formatFromDateForAPI(defaultDates.fromDate),
      todate: formatToDateForAPI(defaultDates.toDate),
      pageNo: 0,
      pageSize: 10,
      sortOrder: 'desc',
      sortColumn: 'pickup_date',
      tableName: ''});
    this.fetchSuggestions();
    this.setState({ loader: false });
}

convertToTimeZone = (requestDate) => {
  const currentUserLang = localStorage.getItem('i18nextLng');
  let zone;
  zone = sessionStorage.getItem('timeZone');
  // Backend sometimes sends 0/"0" for "no date"
  if (
    requestDate === 0 ||
    requestDate === '0' ||
    requestDate === null ||
    requestDate === undefined ||
    requestDate === 'null' ||
    requestDate === 'undefined'
  ) {
    return '';
  }
  const date = moment(new Date(requestDate));
  if (!date.isValid()) return '';
  if(['null', null, 'undefined', undefined].includes(zone)){
    zone = defaultZone;
  }
  return currentUserLang === 'en' ? date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('MM/DD/YYYY hh:mm:ss A') : date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('DD/MM/YYYY hh:mm:ss A');
}

  exportCSV() {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'CSV/PayrollDeductReport', {
      method: 'POST',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(TransactionFilterObj)
    })
    .then(response => {
      try{
        return response.json();
      }catch(error){
        return null;
      }
    })
    .then((csvData) => {
      this.setState({ loader: false });
      let csvRow=[];
        let Array = [[
          'First Name',
          'Last Name',
          'Badge Number',
          'Store',
          'Location',
          'Delivery Type',
          'BIN',
          'Rx #',
          'Fill ID',
          'Prescription Number',
          'Order ID',
          'Transaction ID',
          'Stock Code',
          'PU Code',
          'NDC Code',
          'Drug Name',
          'Qty',
          'Amount Due',
          'Stock Date',
          'Pick Up Date',
        ]];
      let result = csvData && csvData.Results && csvData.Results.length > 0 ? csvData.Results : [];
      if(result !== undefined && result !== 'undefined'){
       if(result && result.length > 0){
        for(let i of result){
              Array.push(
                [
                  i.firstname ? i.firstname : '-',
                  i.lastname ? i.lastname : '-',
                  i.member_id ? i.member_id : '-',
                  i.store ? i.store : '-',
                  i.box ? i.box : '-',
                  i.deliverytype ? i.deliverytype : '-',
                  i.binid ? i.binid : '-',
                  i.rxno ? i.rxno : '-',
                  i.fillid ? i.fillid : '-',
                  i.prescriptionnumber ? i.prescriptionnumber : '-',
                  i.order_id ? i.order_id : '-',
                  i.prescription_txn_id ? i.prescription_txn_id : '-',
                  i.stock_code ? i.stock_code : '-',
                  i.pucode ? i.pucode : '-',
                  i.ndccode ? i.ndccode : '-',
                  i.drugname ? i.drugname : '-',
                  i.qty ? i.qty : '-',
                  i.amount ? '$' + parseFloat(i.amount).toFixed(2) : '$0.00',
                  i.stockeddate ? this.convertToTimeZone(i && i.stockeddate) : '-',
                  i.pickupdate ? this.convertToTimeZone(i && i.pickupdate) : '-',
                ]

            );
        }

          for(let i of Array){
             csvRow.push(i.join(","));
          }
          let csvString = csvRow.join("\n");
          generateCSV({
            data: csvString,
            fileName: "PayrollDeductionsReport.csv",
            fileType: "text/csv;charset=utf-8;"
          });
        }
      }
    });
  };

  gettingOnSortTableName = (field) => {
    let tablename = '';
    if(['firstname', 'lastname', 'member_id'].includes(field)){
      tablename = 'customers';
    }
    if(['box'].includes(field)){
      tablename = 'boxes';
    }
    if(['rxno', 'drugname'].includes(field)){
      tablename = 'prescription_detail';
    }
    if(['stock_code', 'pucode', 'stockeddate', 'pickupdate'].includes(field)){
      tablename = 'prescriptions_master';
    }
    return tablename;
  }

  handleRequestSort = (event, property, field) => {
    const orderBy = property;
    let order = "desc";
    if (this.state.order === "desc") {
      order = "asc";
    }
    this.setState({ order, orderBy, sortId: property });
    TransactionFilterObj.sortOrder = order;
    TransactionFilterObj.sortColumn = field;
    TransactionFilterObj.tableName = this.gettingOnSortTableName(orderBy);
    
    if (this.state.data && this.state.data.length > 0){
      this.BindGrid();
    }
  };

  handleChangePage = (event, page) => {
    event && event.preventDefault();
    
    TransactionFilterObj.pageNo = page;
    if (this.state.data && this.state.data.length > 0) {
      this.BindGrid();
    }
  };

  handleChangeRowsPerPage = event => {
    
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.pageSize = event.target.value;
    if (this.state.data && this.state.data.length > 0) {
      this.BindGrid();
    }
  };

  //Bind Boxes by store id
  BindBoxesbyStoreId(store_ids){
    if(store_ids.length > 0)
    {
      this.setState({loader:true});
      let BoxesObj = {
        store_ids:store_ids
      }
        fetch(process.env.REACT_APP_BASEURL + 'getBoxesByStoreIds', {
        method: 'post',
        withCredentials: true,
        headers: {
          'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(BoxesObj)
      })
      .then(response => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then(data => {
        const {t} = this.props;
        let All = [{id: "-1", name: t("Global.Label.DropDown.All")}]
        const boxlist = data.map(account => {
          return { id: account.id, name: account.name };
        });
        const boxvalues = All.concat(boxlist);
        this.setState({ chipboxes : [] });
        this.setState({ nboxes : [] });
          this.setState({ boxvalues : boxvalues });
          this.setState({loader:false});
      });
     }
  }

  handleStoreChange = event => {
    const storeid=event.target.value;
    const storeids = [];
    let processed = [];
    let chipprocessed = [];
    const AllprocessedIndex = storeid.findIndex(x => x.id === '-1');
    
    if(AllprocessedIndex > -1)
    {
      chipprocessed = [this.state.accountValues[0]];
      for(let i=0;i< this.state.accountValues.length ;i++)
      {
        processed.push(this.state.accountValues[i]);
      }
    }
    else if(storeid.length === 0)
    {
      chipprocessed=[];
      processed=[];
    }
    else if(storeid.length > 0)
    {
        for (let i = 0; i < event.target.value.length; i++)
        {
          const element = event.target.value[i];
          if(element.id !== '-1')
          {
            chipprocessed.push(element);
            processed.push(element);
          }
        }
    }
    
    this.setState({ chipstores: chipprocessed });
    this.setState({ nstores: processed });

    if(processed.length > 0)
    {
      for(let i=0;i < processed.length ;i++)
      {
        if(processed[i].id !== '-1')
        {
          storeids.push(processed[i].id)
        }
      }
    }
    this.setState({store_id: storeids});
    TransactionFilterObj.store_ids = storeids;
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'pickup_date';
    TransactionFilterObj.tableName = '';
    this.BindBoxesbyStoreId(storeids);
    this.BindGrid();
  };
  handleBoxChange = event => {
    const boxid=event.target.value;
    const boxids = [];

    let processed = [];
    let chipprocessed = [];
    const AllprocessedIndex = boxid.findIndex(x => x.id === '-1');
    
    if(AllprocessedIndex > -1)
    {
      chipprocessed = [this.state.boxvalues[0]];
      for(let i=0;i< this.state.boxvalues.length ;i++)
      {
        processed.push(this.state.boxvalues[i]);
      }
    }
    else if(boxid.length === 0)
    {
      chipprocessed=[];
      processed=[];
    }
    else if(boxid.length > 0)
    {
      for (let i = 0; i < event.target.value.length; i++)
        {
          const element = event.target.value[i];
          if(element.id !== '-1')
          {
            chipprocessed.push(element);
            processed.push(element);
          }
        }
    }
    
    this.setState({ chipboxes: chipprocessed });
    this.setState({ nboxes: processed });

    if(processed.length > 0)
    {
      for(let i=0;i < processed.length ;i++)
      {
        if(processed[i].id !== '-1')
        {
          boxids.push(processed[i].id)
        }
      }
    }
    this.setState({box_id: boxids});
    TransactionFilterObj.box_ids = boxids;
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'pickup_date';
    TransactionFilterObj.tableName = '';
    this.BindGrid();
  };

  handleDeleteStoreChip = (chipToDelete) => (event) => {
    if (event && event.stopPropagation) {
      event.stopPropagation();
    }
    if (chipToDelete.id === '-1') {
      this.setState({ chipstores: [], nstores: [], store_id: [] });
      TransactionFilterObj.store_ids = [];
      TransactionFilterObj.pageNo = 0;
      this.BindBoxesbyStoreId([]);
      this.BindGrid();
      return;
    }
    const updatedStores = this.state.chipstores.filter(chip => chip.id !== chipToDelete.id);
    const updatedNStores = this.state.nstores.filter(store => store.id !== chipToDelete.id);
    this.setState({ chipstores: updatedStores, nstores: updatedNStores });
    const storeids = updatedNStores.filter(s => s.id !== '-1').map(s => s.id);
    this.BindBoxesbyStoreId(storeids);
    TransactionFilterObj.store_ids = storeids;
    TransactionFilterObj.pageNo = 0;
    this.BindGrid();
  };

  handleDeleteBoxChip = (chipToDelete) => (event) => {
    if (event && event.stopPropagation) {
      event.stopPropagation();
    }
    if (chipToDelete.id === '-1') {
      this.setState({ chipboxes: [], nboxes: [], box_id: [] });
      TransactionFilterObj.box_ids = [];
      TransactionFilterObj.pageNo = 0;
      this.BindGrid();
      return;
    }
    const updatedBoxes = this.state.chipboxes.filter(chip => chip.id !== chipToDelete.id);
    const updatedNBoxes = this.state.nboxes.filter(box => box.id !== chipToDelete.id);
    this.setState({ chipboxes: updatedBoxes, nboxes: updatedNBoxes });
    const boxids = updatedNBoxes.filter(b => b.id !== '-1').map(b => b.id);
    TransactionFilterObj.box_ids = boxids;
    TransactionFilterObj.pageNo = 0;
    this.BindGrid();
  };

  handleClearAllStores = (event) => {
    if (event && event.stopPropagation) {
      event.stopPropagation();
    }
    this.setState({ chipstores: [], nstores: [], store_id: [] });
    TransactionFilterObj.store_ids = [];
    TransactionFilterObj.pageNo = 0;
    this.BindBoxesbyStoreId([]);
    this.BindGrid();
  };

  handleClearAllBoxes = (event) => {
    if (event && event.stopPropagation) {
      event.stopPropagation();
    }
    this.setState({ chipboxes: [], nboxes: [], box_id: [] });
    TransactionFilterObj.box_ids = [];
    TransactionFilterObj.pageNo = 0;
    this.BindGrid();
  };
   //Search Text Box change event
  onSearchChange = (event) => {
    this.debouceTimeout && clearTimeout(this.debouceTimeout);
    const searchString = event.target.value;
    this.setState({ searchtext: searchString && searchString });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'pickup_date';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.searchtext = searchString;
    this.debouceTimeout = setTimeout(() => {
      this.BindGrid();
    }, 300);
  }
  onFromDateSelect = date => {
    const dateObj = date ? moment(date) : null;
    this.setState({ fromdate: dateObj, dateRangePreset: '' });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'pickup_date';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.fromdate = formatFromDateForAPI(dateObj);
    this.BindGrid();
  };
  onToDateSelect = date => {
    const dateObj = date ? moment(date) : null;
    this.setState({ todate: dateObj, dateRangePreset: '' });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'pickup_date';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.todate = formatToDateForAPI(dateObj);
    this.BindGrid();
  };
  handleBlurfrom =  (value,date) => {
    const dateObj = date ? moment(date) : null;
    this.setState({
      fromdate: dateObj,
      dateRangePreset: ''
    });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'pickup_date';
    TransactionFilterObj.tableName = ''
    TransactionFilterObj.fromdate = formatFromDateForAPI(dateObj);
    this.BindGrid();
  }
  handleBlurtodate = (value,date) => {
    const dateObj = date ? moment(date) : null;
    this.setState({
      todate: dateObj,
      dateRangePreset: ''
    });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'pickup_date';
    TransactionFilterObj.tableName = ''
    TransactionFilterObj.todate = formatToDateForAPI(dateObj);
    this.BindGrid();
  }
  
  handleDateRangePresetChange = (event) => {
    const preset = event.target.value;
    if (!preset) return;
    
    const dateRange = getDateRangeByPreset(preset);
    this.setState({
      fromdate: dateRange.fromDate,
      todate: dateRange.toDate,
      dateRangePreset: preset
    });
    
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'pickup_date';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.fromdate = formatFromDateForAPI(dateRange.fromDate);
    TransactionFilterObj.todate = formatToDateForAPI(dateRange.toDate);
    this.BindGrid();
  };

  BindGrid = () => {
    if (this.gridApi) {
      this.refreshGrid();
      return;
    }
    // SSRM datasource is attached in onGridReady; avoid a parallel
    // legacy fetch/setState race that leaves the grid on Please Wait...
    this.setState({ loader: false });
  };
handlePUcodeClick=(event, pmid)=>{
  if (event && typeof event.preventDefault === 'function') event.preventDefault();
  this.setState({ tempThresholds: [] });
  const selectedObject = resolveGridRow(pmid, this.state.data, (x, id) => x.pmid === id);
  if (!selectedObject) return;
  this.setState({detailDialogOpen:true,selectedObject:selectedObject})
  this.setState({
    boxAddress: ( selectedObject.address_line_1 + ' '
    + selectedObject.address_line_2 + ','
    + selectedObject.city + ', '
    + selectedObject.state + ' '
    + selectedObject.zip + '')
  })
}
handlePUcodeClose = (event) =>{
  event.preventDefault();
  this.setState({detailDialogOpen:false,selectedObject:null, selectedTab: 0})
}
handlePrintReceipt = () => {
  this.setState({detailDialogOpen: false, printDialogOpen: true })
  setTimeout(() => {
    window.print();
    this.setState({ printDialogOpen: false ,detailDialogOpen: false, selectedObject: null })
  }, 100);
}

  handleTabChange = (event, index) => {
    this.setState({ selectedTab: index });
  };

  handleChangeIndex(index) {
    this.setState({ selectedTab: index });
  };

  handleTemperatureHistory = () => {
    this.getTemperatureHistoryByOrderId();
  }

  getTemperatureHistoryByOrderId = () => {
    let temperatureHistory = {
      startdate: this.state.selectedObject.stockeddate,
      enddate: this.state.selectedObject.pickupdate,
      orderId: this.state.selectedObject.pmid
    }
    fetch(process.env.REACT_APP_BASEURL + 'temperature/history/by/expansion', {
      method: 'post',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(temperatureHistory)
    }).then(response => {
      try {
        return response.json();
      } catch (error) {
        return null;
      }
    }).then(tempData => {
      if (tempData && tempData.length > 0) {
        this.setState({ tempThresholds: tempData });
      }
    });
  }

  exportTemperatureHistory = () => {
    let csvRow = [];
    let A = [['' ,'Temperature', 'Date']];
    let re = this.state !== null ? this.state.tempThresholds : [];
    if (re !== undefined) {
      if (re.length > 0) {
        for (let item = 0; item < re.length; item++) {
          A.push([re[item].temperature,
          re[item].date ? this.convertToTimeZone(re[item].date) : '',
          ]);
        }
        for (let i = 0; i < A.length; ++i) {
          csvRow.push(A[i].join(","));
        }
        let csvString = csvRow.join("\n");
        generateCSV({
          data: csvString,
          fileName: `TemperatureHistory_${new Date()}.csv`,
          fileType: "text/csv;charset=utf-8;"
        });
      }
    }
  }

  handleInputChange = (event) => {
    this.setState({ queryId: event.target.value });
    TransactionFilterObj.group_id = event.target.value
    this.BindGrid();
  };

  fetchSuggestions = async () => {
    try {
      const result = fetch(`${process.env.REACT_APP_BASEURL}groups/search`, {
        method: "GET",
        withCredentials: true,
        headers: {
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
              .jwtToken,
          "Content-Type": "application/json",
        },
      }
      );
      result
        .then((result) => {
          result.json().then((resLocation) => {
            this.setState({ groups: resLocation && resLocation.data })
          })
        })
    } catch (error) {
      console.error("Error fetching groups:", error);
    }
  };

  render() {
    const {classes, theme, t} = this.props;
    return (
      <div id="react-no-print" className={classes.root}>
       {
        this.state.loader ?
        <div className={classes.spinner}>
          <img className={classes.spinnerImage} src={spinner} alt="loading" />
        </div>:
        null
      }
        <div id="react-no-print">
          <Dialog
          open={this.state.detailDialogOpen || false}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          PaperProps= {{
            style: {borderRadius:'5px',maxWidth:'100%',width:'60%'}
          }}
        >
              <AppBar position="static" color="default">
                <Tabs
                  value={this.state.selectedTab}
                  onChange={this.handleTabChange}
                  indicatorColor="primary"
                  textColor="primary"
                  variant={null}
                >
                  <Tab label={t("Report.Payroll.PatientDetail.PatientDetailsTitle")} />
                  <Tab label={t("Report.Payroll.Temperature.TemperatureHistoryTitle")} onClick={this.handleTemperatureHistory}/>
                </Tabs>
              </AppBar>
              <SwipeableViews
                axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                index={this.state.selectedTab}
                onChangeIndex={() => this.handleChangeIndex}
              >
                <TabContainer dir={theme.direction}>
                  <DialogTitle id="alert-dialog-title">{t("Report.Payroll.PatientDetail.PickupByText")}</DialogTitle>
                  <DialogContent>
                    <Table aria-labelledby="tableTitle">
                      <TableHead>
                        <TableRow>
                          <TableCell className={classes.padding10px} style={{color:'grey'}}>{t("Report.Payroll.PatientDetail.FirstName")}</TableCell>
                          <TableCell className={classes.padding10px} style={{color:'grey'}}>{t("Report.Payroll.PatientDetail.LastName")}</TableCell>
                          <TableCell className={classes.padding10px} style={{color:'grey'}}>{t("Report.Payroll.PatientDetail.BadgeNumber")}</TableCell>
                          <TableCell className={classes.padding10px} style={{color:'grey'}}>{t("Report.Payroll.PatientDetail.ContactlessPickup")}</TableCell>
                          <TableCell className={classes.padding10px} style={{color:'grey'}}>{t("Report.Payroll.PatientDetail.DLNo")}</TableCell>
                          <TableCell className={classes.padding10px} style={{color:'grey'}}>{t("Report.Payroll.PatientDetail.Signature")}</TableCell>
                          <TableCell className={classes.padding10px} style={{color:'grey'}}>{t("Report.Payroll.PatientDetail.Picture")}</TableCell>
                          <TableCell className={classes.padding10px} style={{color:'grey'}}>{t("Report.Payroll.PatientDetail.Relationship")}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {
                          this.state.selectedObject !== null ?
                            <TableRow>
                              <TableCell className={classes.padding10px} >{this.state.selectedObject.pfirst_name ? this.state.selectedObject.pfirst_name : ''}</TableCell>
                              <TableCell className={classes.padding10px}>{this.state.selectedObject.plast_name ? this.state.selectedObject.plast_name : ''}</TableCell>
                              <TableCell className={classes.padding10px}>{this.state.selectedObject.iscontactlessactivated === true ? 'Yes' : 'No'}</TableCell>
                              <TableCell className={classes.padding10px}>{this.state.selectedObject.pdrivers_license_no ? this.state.selectedObject.pdrivers_license_no : ''}</TableCell>
                              <TableCell className={classes.padding10px}><img style={{ borderRadius: '0%', width: '230px', height: '150px' }} alt="" src={(this.state.selectedObject.psignature_url !== null && this.state.selectedObject.psignature_url !== '') ? this.state.selectedObject.psignature_url : '/static/dashboard/global_assets/images/placeholders/no-image.svg'} /></TableCell>
                              <TableCell className={classes.padding10px}><Avatar style={{ borderRadius: '0%', width: '150px', height: '150px' }} alt="" src={(this.state.selectedObject.ppicture_url !== null && this.state.selectedObject.ppicture_url !== '') ? this.state.selectedObject.ppicture_url : '/static/dashboard/global_assets/images/placeholders/no-image.svg'} /></TableCell>
                              <TableCell className={classes.padding10px}>{this.state.selectedObject.relationship ? this.state.selectedObject.relationship.replace('_', ' ').replace('_', ' ') : ''}</TableCell>
                            </TableRow>
                            :
                            <TableRow>
                              <TableCell colSpan={5}>{t("Report.Payroll.NoDataFound")}</TableCell>
                            </TableRow>
                        }
                      </TableBody>
                    </Table>
                  </DialogContent>
                </TabContainer>
                <TabContainer dir={theme.direction}>
                  <DialogTitle id="form-dialog-title">{t("Report.Payroll.Temperature.TemperatureHistoryText")}</DialogTitle>
                  <DialogContent>
                    <Grid container>
                      <Grid item xs={11} className="font-style">
                        &nbsp;
                      </Grid>
                      <Grid item xs={1} className="font-style">
                        <img alt="download" onClick={()=>{this.exportTemperatureHistory()}} src={download} style={{height:'32px',width:'32px',cursor:'pointer'}}/>
                      </Grid>
                    </Grid>
                    <Dashboard data={this.state && this.state.tempThresholds} startDate={this.state && this.state.selectedObject && this.state.selectedObject.stockeddate} endDate={this.state && this.state.selectedObject && this.state.selectedObject.pickupdate} margin="0%" convertTimeZone={this.convertToTimeZone} />
                  </DialogContent>
                </TabContainer>
              </SwipeableViews>
          <DialogActions>
            <Button onClick={(e)=>{this.handlePrintReceipt(e)}} color="primary" className={classes.primaryButton}>
               {t("Report.Payroll.Temperature.PrintReceiptButton")}
            </Button>
            <Button onClick={(e)=>{this.handlePUcodeClose(e)}} color="primary" className={classes.primaryButton}>
              {t("Report.Payroll.Temperature.CloseButton")}
            </Button>
          </DialogActions>
        </Dialog>
        </div>
        <div>
        <Dialog
              open={this.state.printDialogOpen || false}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              fullWidth={true}
              PaperProps= {{
                style: {maxWidth:'700px',maxHeight:'100%'}
              }}
            >
              <DialogTitle id="alert-dialog-title">{t("Report.Payroll.Receipt.PickedUpReceipt")}</DialogTitle>
              <DialogContent>
                <Table aria-labelledby="tableTitle">
                  {
                    this.state.selectedObject !== null ?
                      (<TableBody>
                        <TableRow className={classes.rowheight}>
                          <TableCell>{t("Report.Payroll.Receipt.PharmacyName")}:</TableCell>
                          <TableCell>{this.state.selectedObject.store}</TableCell>
                        </TableRow>
                        <TableRow className={classes.rowheight}>
                          <TableCell>{t("Report.Payroll.Receipt.KioskName")}:</TableCell>
                          <TableCell>{this.state.selectedObject.box}</TableCell>
                        </TableRow>
                        <TableRow className={classes.rowheight}>
                          <TableCell>{t("Report.Payroll.Receipt.Address")}:</TableCell>
                          <TableCell>{this.state && this.state.boxAddress}</TableCell>
                        </TableRow>
                        <TableRow className={classes.rowheight}>
                          <TableCell>{t("Report.Payroll.Receipt.PickupOrder")}:</TableCell>
                          <TableCell>{this.state.selectedObject.pucode}</TableCell>
                        </TableRow>
                        <TableRow className={classes.rowheight}>
                          <TableCell>{t("Report.Payroll.Receipt.PickupDate")}:</TableCell>
                          <TableCell>{this.state.selectedObject.pickupdate ? this.convertToTimeZone(this.state.selectedObject.pickupdate) : ''}</TableCell>
                        </TableRow>
                        <TableRow className={classes.rowheight}>
                          <TableCell>{t("Report.Payroll.Receipt.StockDate")}:</TableCell>
                          <TableCell>{this.state.selectedObject.stockeddate ? this.convertToTimeZone(this.state.selectedObject.stockeddate) : ''}</TableCell>
                        </TableRow>
                        <TableRow className={classes.rowheight}>
                          <TableCell>{t("Report.Payroll.Receipt.PatientName")}:</TableCell>
                          <TableCell>{this.state.selectedObject.username}</TableCell>
                        </TableRow>
                        <TableRow className={classes.rowheight}>
                          <TableCell style={{ borderBottom : 'none'}}><b>{t("Report.Payroll.Receipt.OrderDetail")}</b></TableCell>
                        </TableRow>
                        <TableRow className={classes.rowheight}>
                          <Table size="small" aria-label="a dense table">
                            {/* <TableHead> */}
                              <TableRow>
                                <TableCell>{t("Report.Payroll.Receipt.PrescriptionNumber")}</TableCell>
                                <TableCell align="right">{t("Report.Payroll.Receipt.RxNumber")}</TableCell>
                                <TableCell align="right">{t("Report.Payroll.Receipt.FillID")}</TableCell>
                              </TableRow>
                            {/* </TableHead> */}
                            <TableBody>
                              {/* {rows.map((row) => ( */}
                                <TableRow className={classes.rowheight}>
                                  <TableCell component="th" scope="row">
                                    {this.state.selectedObject.rxno}
                                  </TableCell>
                                  <TableCell align="right">{this.state.selectedObject.prescriptionnumber}</TableCell>
                                  <TableCell align="right">{this.state.selectedObject.fillid}</TableCell>
                                </TableRow>
                              {/* ))} */}
                            </TableBody>
                          </Table>
                        </TableRow>
                        <TableRow className={classes.rowheight}>
                          <TableCell style={{ borderBottom : 'none'}}><b>{t("Report.Payroll.Receipt.Signature")}</b></TableCell>
                        </TableRow>
                        <TableRow className={classes.rowheight}>
                          <TableCell><Avatar style={{ border:'1px solid rgba(224, 224, 224, 1)', borderRadius: '0%',width:'100%',height:'150px' }}  alt="" src={(this.state.selectedObject.psignature_url !== null && this.state.selectedObject.psignature_url !== '') ? this.state.selectedObject.psignature_url : '/static/dashboard/global_assets/images/placeholders/no-image.svg'} /></TableCell>
                        </TableRow>
                        <TableRow className={classes.rowheight}>
                          <TableCell style={{ borderBottom : 'none'}}><b>{t("Report.Payroll.Receipt.PickedUpBy")}</b></TableCell>
                        </TableRow>
                        <TableRow className={classes.rowheight}>
                          <TableCell>{t("Report.Payroll.Receipt.FirstName")}:</TableCell>
                          <TableCell>{this.state.selectedObject.pfirst_name}</TableCell>
                        </TableRow>
                        <TableRow className={classes.rowheight}>
                          <TableCell>{t("Report.Payroll.Receipt.LastName")}:</TableCell>
                          <TableCell>{this.state.selectedObject.plast_name}</TableCell>
                        </TableRow>
                        <TableRow className={classes.rowheight}>
                          <TableCell>{t("Report.Payroll.PatientDetail.BadgeNumber")}:</TableCell>
                          <TableCell>{this.state.selectedObject.member_id}</TableCell>
                        </TableRow>
                        <TableRow className={classes.rowheight}>
                          <TableCell>{t('Report.Payroll.Receipt.IDNo')}:</TableCell>
                          <TableCell>{this.state.selectedObject.pdrivers_license_no}</TableCell>
                        </TableRow>
                        <TableRow className={classes.rowheight}>
                          <TableCell><Avatar style={{ borderRadius: '0%',width:'60%',height:'150px' }}  alt="" src={(this.state.selectedObject.ppicture_url !== null && this.state.selectedObject.ppicture_url !== '') ? this.state.selectedObject.ppicture_url   : '/static/dashboard/global_assets/images/placeholders/no-image.svg'}/></TableCell>
                        </TableRow>
                      </TableBody>)
                      :
                      (<TableBody>
                        <TableRow>
                          <TableCell colSpan={5}>{t("Report.Payroll.NoDataFound")}</TableCell>
                        </TableRow>
                      </TableBody>)
                  }
                </Table>
              </DialogContent>
        </Dialog>
        </div>
        
                <Box component="div">
          <Grid container direction={'row'} alignItems={'center'} justifyContent={'flex-end'} spacing={2} sx={{ mt: 0, ml: 0, width: '100%', p: '0% 2% 1%' }}>
            <Grid item xs={12} md={12} sx={{ textAlign: 'end' }}>
              <Tooltip key="single-edit" title={t("Report.Payroll.ExportCSVTooltip")}>
                                    <IconButton
                                      style={{ marginRight: '0'}}
                                      aria-label="ExportCSV"
                                      onClick={()=>{this.exportCSV()}}
                                      disabled={this.state.isDisabledButton}
                                    >
                                    <img alt="download"  src={download} style={{height:'32px',width:'32px',cursor:'pointer'}}/>
                                    </IconButton>
                                </Tooltip>
            </Grid>
          </Grid>
        </Box>
      <Divider style={{marginTop:'10px',height:'5px'}}/>

        <div className={classes.tableWrapper}>
         <ILocalAGGrid
            columnDefs={[
              { field: 'firstname', headerName: t("Report.Payroll.FirstName"), colId: 'firstname' },
              { field: 'lastname', headerName: t("Report.Payroll.LastName"), colId: 'lastname' },
              { field: 'member_id', headerName: t("Report.Payroll.BadgeNumber"), colId: 'member_id' },
              { field: 'store', headerName: t("Report.Payroll.Store"), colId: 'store' },
              { field: 'box', headerName: t("Report.Payroll.Location"), colId: 'box' },
              { field: 'deliverytype', headerName: t("Report.Payroll.DeliverType"), colId: 'deliverytype', valueFormatter: (p) => getTypeByLang(p.value, t) },
              { field: 'binid', headerName: t("Report.Payroll.BIN"), colId: 'binid' },
              { field: 'rxno', headerName: t("Report.Payroll.RxHash"), colId: 'rxno' },
              { field: 'fillid', headerName: t("Report.Payroll.FillID"), colId: 'fillid' },
              { field: 'prescriptionnumber', headerName: t("Report.Payroll.PrescriptionNumber"), colId: 'prescriptionnumber' },
              { field: 'order_id', headerName: t("Report.Payroll.OrderID"), colId: 'OrderId' },
              { field: 'prescription_txn_id', headerName: t("Report.Payroll.TransactionID"), colId: 'PrescriptionTxnId' },
              { field: 'stock_code', headerName: t("Report.Payroll.StockCode"), colId: 'stock_code' },
              withClickableCell(
                { field: 'pucode', headerName: t("Report.Payroll.PUCode"), colId: 'pucode' },
                (e, row) => this.handlePUcodeClick(e, row)
              ),
              { field: 'ndccode', headerName: t("Report.Payroll.NDCCode"), colId: 'ndccode' },
              { field: 'drugname', headerName: t("Report.Payroll.DrugName"), colId: 'drugname' },
              { field: 'qty', headerName: t("Report.Payroll.Qty"), colId: 'qty' },
              { field: 'amount', headerName: t("Report.Payroll.AmountDue"), colId: 'amount', valueFormatter: (p) => p.value ? '$' + parseFloat(p.value).toFixed(2) : '$0.00' },
              { field: 'stockeddate', headerName: t("Report.Payroll.StockDate"), colId: 'stockeddate', valueFormatter: (p) => p.value ? this.convertToTimeZone(p.value) : '' },
              withDateColumnFilter({ field: 'pickupdate', headerName: t("Report.Payroll.PickUpDate"), colId: 'pickupdate', valueFormatter: (p) => p.value ? this.convertToTimeZone(p.value) : '' }),
            ]}
            defaultColDef={getDefaultColDef()}
            rowModelType="serverSide"
            cacheBlockSize={TransactionFilterObj.pageSize || 10}
            paginationPageSize={TransactionFilterObj.pageSize || 10}
            paginationPageSizeSelector={[10, 20, 25]}
            rowHeight={40}
            getRowId={(params) =>
              (params.data && (params.data.prescription_txn_id || params.data.id || params.data.pmid || params.data.uuid)) ||
              String(params.data && JSON.stringify(params.data).slice(0,40))
            }
            onGridReady={this.onGridReady}
            onPaginationChanged={this.onPaginationChanged}
          />
        </div>
      </div>
    );
  }
}

EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles, { withTheme: true })(withTranslation()(EnhancedTable));



// WEBPACK FOOTER //
// ./src/components/reports/payroll-deductions/index.js